import { render, staticRenderFns } from "./noLeft.vue?vue&type=template&id=a46c85e8&scoped=true"
import script from "./noLeft.vue?vue&type=script&lang=js"
export * from "./noLeft.vue?vue&type=script&lang=js"
import style0 from "./noLeft.vue?vue&type=style&index=0&id=a46c85e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46c85e8",
  null
  
)

export default component.exports